<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <multiselect
                        v-model="search.sale_id"
                        class="form-control select"
                        :options="OptionSeller"
                        :show-labels="false"
                        placeholder="กรุณาเลือกเซลล์"
                        label="name"
                        :multiple="true"
                        :closeOnSelect="false"
                        style="border-style: none;height: 100%"
                        track-by="id">
                    </multiselect>
                    &nbsp
                    <multiselect
                        style="height: 100%"
                        v-model="search.code"
                        class="form-control border-0"
                        :options="optionProducts"
                        :customLabel="LabelSkuWithName"
                        placeholder="ค้นหาสินค้า"
                        :show-labels="false"
                        :close-on-select="false"
                        multiple
                        :searchable="true"
                        track-by="id">
                    </multiselect>
                    &nbsp
                    <!--                    <input v-model="search.code"-->
                    <!--                           class="form-control mr-sm-2"-->
                    <!--                           type="search"-->
                    <!--                           placeholder="รหัสสินค้า"-->
                    <!--                           aria-label="Search"-->
                    <!--                    /> &nbsp-->
                    <select class="form-control" v-model="search.type">
                        <option v-for="options in productType"
                                :value="options.value">
                            {{ options.text }}
                        </option>
                    </select> &nbsp
                    <date-picker v-model="search.date"
                                 range
                                 :disabled="search.month ? true : false"
                                 @clear="clearDate()"
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang" confirm>
                    </date-picker>
                    &nbsp
                    <date-picker
                        :disabled="search.date.length > 0 ? true : false"
                        :lang="lang"
                        @clear="clearDate()"
                        type="month"
                        :format="changeFormat"
                        v-model="search.month"
                        placeholder="เดือน-ปี"
                        format="MM/YYYY">
                    </date-picker>
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchOverview"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button class="btn btn-info" type="button" @click="printOverviewProductsExcel">
                        <icon name="print"></icon>
                        พิมพ์ข้อมูล Excel
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>
        <!--        <div style="padding-right: 10px; color: red">**รายงานการจองจะแสดงการจองของวันปัจจุบัน กรุณาเลือกวันที่เพื่อดูรายงานการจองของแต่ละวัน</div>-->
        <div style="padding-right: 10px; color: red">**รายงานการจองจะแสดงการจองทั้งหมด
            และการจองของเดือนนี้หากไม่ได้เลือกวันที่
        </div>
        <div class="col-sm-12 center table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสสินค้า</th>
                    <template v-for="(data,index) in seller">
                        <th scope="col">{{ data.sale_id + ' ' + data.name }}</th>
                        <th v-if="index+1 == seller.length && showing">รวม</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in reservation">
                    <template v-if="index != 'foot'" v-for="(row,i) in data">
                        <td v-if="i == 0">{{ row }}</td>
                        <td v-else>
                            <template v-if="row.total">{{ row.total }}</template>
                            <template v-else-if="row == ''">-</template>
                            <template v-else-if="i+1 == data.length">{{ row }}</template>
                            <template v-else>-</template>
                        </td>
                    </template>
                    <template v-if="index == 'foot' && showing">
                        <template v-for="(row,i) in data">
                            <td>{{ row }}</td>
                        </template>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <br/>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Table from "bootstrap-vue/src/components/table/table";
import VuePagination from "../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from 'moment';
import {domain} from "../../util/Constants";
import Multiselect from "vue-multiselect"

export default {
    components: {
        VuePagination,
        DatePicker,
        Table,
        Multiselect
    },
    name: "reservations-table",
    data() {
        return {
            reservation: [],
            seller: [],
            showing: true,
            showing_foot: true,
            page: 1,
            search: {
                date: [],
                code: [],
                type: "",
                sale_id: [],
                export: "",
                month: ''
            },
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.$store.dispatch('ProductType/get');
        this.search.month = moment().format('YYYY-MM');
        this.getOverView();
    },
    computed: {
        ...mapState({
            productType: state => {
                return [
                    {
                        value: "",
                        text: "ประเภทสินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            user: state => {
                return state.Auth.user;
            },
            OptionSeller: state => {
                return state.Seller.data;
            },
            optionProducts: state => {
                return state.ProductType.product;
            },
        })
    },
    methods: {
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.name}`
            }
        },
        clearDate() {
            this.search.date = [];
            this.search.month = '';
        },
        getOverView() {
            let product_id = '';
            this.search.code.forEach((v, i) => {
                i > 0 ? product_id += ',' + v.id : product_id += v.id;
            })
            let data = {
                start_date: this.search.date.length > 0 ? moment(this.search.date[0]).format('YYYY-MM-DD') : '',
                end_date: this.search.date.length > 0 ? moment(this.search.date[1]).format('YYYY-MM-DD') : '',
                product_sku: product_id,
                product_type_id: this.search.type ? this.search.type : '',
                month: moment(this.search.month).format('YYYY-MM'),
                sale_id: '',
            }
            this.search.sale_id.forEach((a, i) => {
                this.search.sale_id.length == i + 1 ? data.sale_id += a.id : data.sale_id += a.id + ',';
            })
            this.$store.dispatch('ProductOverview/get_per_sale', data).then(res => {
                //console.log(res)
                this.reservation = res.data
                this.seller = res.seller
                this.showing = res.showing
            });
        },
        printOverviewProductsExcel() {
            if (this.search.date.length < 1) {
                alert("กรุณาเลือกช่วงวันที่");
            } else {
                let product_id = '';
                this.search.code.forEach((v, i) => {
                    i > 0 ? product_id += ',' + v.id : product_id += v.id;
                })
                let data = {
                    start_date: moment(this.search.date[0]).format('YYYY-MM-DD'),
                    end_date: moment(this.search.date[1]).format('YYYY-MM-DD'),
                    product_sku: product_id,
                    product_type_id: this.search.type,
                    sale_id: this.search.sale_id,
                    month: moment(this.search.month).format('YYYY-MM'),
                    export: 'excel',
                }
                this.search.sale_id.forEach((a, i) => {
                    this.search.sale_id.length == i + 1 ? data.sale_id += a.id : data.sale_id += a.id + ',';
                })
                window.open(`${domain}/overview-product-per-sale?start_date=${data.start_date} +
                                    &end_date=${data.end_date} +
                                    &product_sku=${data.product_sku} +
                                    &product_type_id=${data.product_type_id} +
                                    &month=${data.month} +
                                    &export=${data.export}`);
            }
        },
        searchOverview() {
            // if(this.search.date.length < 1){
            //     alert("กรุณาเลือกช่วงวันที่");
            // }else{
            this.getOverView();
            // }
        }
    }
};
</script>

<style lang="scss" scoped>
.center {
    margin: auto;
    width: 100%;
    padding: 10px;
}

/*td:nth-of-type(1):before {*/
/*content: "ลำดับ";*/
/*}*/
/*td:nth-of-type(2):before {*/
/*content: "รหัสสินค้า";*/
/*}*/
/*td:nth-of-type(3):before {*/
/*content: "ชื่อสินค้า";*/
/*}*/
/*td:nth-of-type(4):before {*/
/*content: "จำนวน";*/
/*}*/
</style>
